import { useTranslation } from 'react-i18next'
import { Avatar, Collapse, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material'

import { NavButton } from '../nav-button.component'
import { useMe } from 'src/hooks'
import { getTableTimestamp } from 'src/common/utils'

import { ETranslationNs, IDraftScanRespDto } from 'src/types'

import { useStyles } from './styles'

interface IGridItemCollapseProps {
  open: boolean
  handleClick?: () => void
  item: IDraftScanRespDto
}

const GridItemCollapse = ({ open, item }: IGridItemCollapseProps) => {
  const [t] = useTranslation()
  const { data: user } = useMe()
  const classes = useStyles()

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <List component="div" className={classes.collapseItemsWrapper}>
        {item.account && (
          <ListItem disablePadding>
            <ListItemAvatar>
              <Avatar
                src={item.account.image_small || item.account.image}
                alt={item.account.account_holder}
              />
            </ListItemAvatar>
            <ListItemText
              primary={item.account.account_holder}
              primaryTypographyProps={{ style: { fontSize: '14px' } }}
            />
          </ListItem>
        )}
        {item.product && (
          <ListItem disablePadding>
            <ListItemAvatar>
              <Avatar
                src={item.product.image_small || item.product.image}
                alt={item.product.name}
              />
            </ListItemAvatar>
            <ListItemText
              primary={item.product.name}
              primaryTypographyProps={{ style: { fontSize: '14px' } }}
            />
          </ListItem>
        )}
        {item.step && (
          <ListItem disablePadding>
            <ListItemAvatar>
              <Avatar src={item.step.image_small || item.step.image} alt={item.step.name} />
            </ListItemAvatar>
            <ListItemText
              primary={item.step.name}
              primaryTypographyProps={{ style: { fontSize: '14px' } }}
            />
          </ListItem>
        )}
        <ListItem disablePadding>
          <ListItemText
            primary={t('table-created-column.v', { ns: ETranslationNs.Common }) + ':'}
            primaryTypographyProps={{ style: { fontSize: '14px' } }}
            secondary={getTableTimestamp({ date: item.created_at, timezone: user?.timezone })}
          />
        </ListItem>

        <ListItem disablePadding>
          <NavButton itemId={item.id} />
        </ListItem>
      </List>
    </Collapse>
  )
}

export { GridItemCollapse }
